import { TrendingUp } from "lucide-react";

interface WasteTableProps {
  baseSqFt: number;
  selectedWaste: number;
}

export function WasteTable({ baseSqFt, selectedWaste }: WasteTableProps) {
  const wastes = [0, 5, 10, 15, 20, 25];
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold flex items-center gap-2">
        <TrendingUp className="w-4 h-4 text-primary" /> Waste Calculation Table
      </h3>
      <div className="rounded-xl border border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-[34rem] w-full table-auto text-sm">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left px-3 py-2 text-xs font-medium text-muted-foreground">Waste %</th>
              {wastes.map((w) => (
                <th
                  key={w}
                  className={`text-center px-3 py-2 text-xs font-medium ${
                    w === selectedWaste ? "bg-destructive/10 text-destructive" : "text-muted-foreground"
                  }`}
                >
                  {w}%{w === selectedWaste && " ★"}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr className="border-t border-border">
              <td className="px-3 py-2 text-xs text-muted-foreground">Area (sq ft)</td>
              {wastes.map((w) => {
                const v = Math.round(baseSqFt * (1 + w / 100));
                return (
                  <td key={w} className={`text-center px-3 py-2 ${w === selectedWaste ? "bg-destructive/5 font-semibold" : ""}`}>
                    {v.toLocaleString()}
                  </td>
                );
              })}
            </tr>
            <tr className="border-t border-border">
              <td className="px-3 py-2 text-xs text-muted-foreground">Squares</td>
              {wastes.map((w) => {
                const v = Math.ceil((baseSqFt * (1 + w / 100)) / 100);
                return (
                  <td
                    key={w}
                    className={`text-center px-3 py-2 ${w === selectedWaste ? "bg-destructive/5 font-bold text-destructive" : ""}`}
                  >
                    {v}
                  </td>
                );
              })}
            </tr>
          </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
